module.exports = __webpack_public_path__ + "img/45_31.a3b34634.png";